export const BUSD_ADDRESS = "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56";
export const STAKING_CONTRACT_ADDRESS =
  "0x7f4e7a180e3ddb79b239180f90bd67070bec951a";
export const ALLOWANCE_MOUNT = "10000000000000000000000000000000000000000";

export const PHX_ADDRESS = "0x9776191F4ebBBa7f358C1663bF82C0a0906c77Fa";
export const PHX_CONTRACT_ADDRESS =
  "0x8e44AA687DF401515dcdF38e0D9fE070CdDcbd28";

// export const BNB_ADDRESS = '0x2170Ed0880ac9A755fd29B2688956BD959F933F8';
export const BNB_CONTRACT_ADDRESS =
  "0x490a78Bf169dC15deb6CD86D9f44879099244753";

//renq config

export const USDT_ADDRESS = "0xff8C479134A18918059493243943150776cF8CF2";
export const USDT_CONTRACT_ADDRESS =
  "0x407CF653C4ebb3c2025DfB7f00D5C0dCFc347dB4";

export const RENQETH_STAKING_ADDRESS =
  "0x526065Babbe97F16b8eA549620Fd0C0860e75ea0";

export const RENQ_ETH_PAIR_ADDRESS =
  "0x9E4c7D0C5Ab9Caa76d443fCB1EBa35F66Bf15BdE";

export const RENQ_USDT_STAKING_ADDRESS =
  "0x732C3deBF107Eb488407BAa79f659DdBA171521a";

export const RENQ_USDT_PAIR_ADDRESS =
  "0xD44971b88A50f1bDF1e5e0A778E6C573A729A78a";
